export default [
  {
    path: '/rolelist',
    name: 'rolelist',
    component: () => import('@/views/admin/rolemanagement/roleList.vue'),
    meta: { title: '角色列表' }
  },
  // {
  //   path: '/rolemanagement',
  //   name: 'rolemanagement',
  //   component: () => import('@/views/rolemanagement/rolemanagement.vue'),
  //   meta: { companyVerify: true, title: '角色管理' }
  // },
  {
    path: '/rolestatu/add',
    name: 'rolestatu-add',
    component: () => import('@/views/admin/rolemanagement/roleStatu.vue'),
    meta: {
      personVerify: true,
      title: '新建角色'
    }
  },
  {
    path: '/rolestatu/edit/:id',
    name: 'rolestatu-edit',
    component: () => import('@/views/admin/rolemanagement/roleStatu.vue'),
    meta: {
      personVerify: true,
      title: '编辑角色'
    }
  },
  {
    path: '/rolestatu/view/:id',
    name: 'rolestatu-view',
    component: () => import('@/views/admin/rolemanagement/roleStatu.vue'),
    meta: {
      personVerify: true,
      title: '查看角色'
    }
  }
]
